module.exports = __webpack_public_path__ + "img/pic-story-tab1-2.850c32c5.jpg";